<template>
    <div class="noDataWrap" :style="`background-color:${backgroundColor};z-index: ${zIndex};`">
        <div class="noDataContent"
             :style="`top: ${top};transform: translate(-50%, -50%) scale(${scale});`">
            <i class="iconfont icon-ziyuan1"></i>
            <span>{{msg}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NoData',// 暂无数据
        props: {
            // 提示语
            msg: {
                type: String,
                default: '亲亲，没有新的数据了~'
            },
            // 高度
            top: {
                type: String,
                default: '50%'
            },
            // 背景色
            backgroundColor: {
                type: String,
                default: 'transparent'
            },
            // 层级
            zIndex: {
                type: String,
                default: '1'
            },
            // 缩放
            scale: {
                type: String,
                default: '1'
            }
        }
    };
</script>

<style lang="scss" scoped>
    .noDataWrap {
        position: absolute;
        top: 0;
        left: 0;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        overflow: hidden;

        .noDataContent {
            position: relative;
            top: 50%;
            left: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .iconfont {
                display: inline-block;
                font-size: 40px;
            }

            > span {
                display: inline-block;
                margin-top: 20px;
                font-size: 18px;
                font-weight: bold;
            }
        }
    }
</style>
